import SystemRequirementsTab from './SystemRequirementsTab';

export default SystemRequirementsTab;
